<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: "30%"
    },
    title: String,
    content: String,
    simple: Boolean,
    btnText: {
      type: String,
      default: "确定"
    },
    btnText2: String,
    showClose: {
      type: Boolean,
      default: true
    },
    Visible: Boolean,
    center: Boolean,
    hideSave: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    useBeforeClose: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    Visible(value) {
      if (value) {
        this.initHeight = this.$el.firstChild.offsetHeight;
        let that = this;
        setTimeout(() => {
          if (that.initHeight !== this.$el.firstChild.offsetHeight) {
            if (
              document.documentElement.clientHeight >
              this.$el.firstChild.offsetHeight
            ) {
              this.$el.firstChild.style["margin-top"] =
                (document.documentElement.clientHeight -
                  this.$el.firstChild.offsetHeight) /
                  2 +
                "px";
            } else {
              this.$el.firstChild.style["margin-top"] = "0px";
            }
          }
        }, 150);
        this.$nextTick(() => {
          that.initHeight = this.$el.firstChild.offsetHeight;
          if (
            document.documentElement.clientHeight >
            this.$el.firstChild.offsetHeight
          ) {
            this.$el.firstChild.style["margin-top"] =
              (document.documentElement.clientHeight -
                this.$el.firstChild.offsetHeight) /
                2 +
              "px";
          } else {
            this.$el.firstChild.style["margin-top"] = "0px";
          }
        });
      }
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
    confirm2() {
      this.$emit("confirm2");
    },
    //关闭前拦截，需要传参数useBeforeClose=true来调用
    beforeClose(done) {
      if (this.useBeforeClose) {
        this.$emit("beforeClose");
      } else {
        done();
      }
    },
    marginAdjust() {
      if (this.initHeight !== this.$el.firstChild.offsetHeight) {
        if (
          document.documentElement.clientHeight >
          this.$el.firstChild.offsetHeight
        ) {
          this.$el.firstChild.style["margin-top"] =
            (document.documentElement.clientHeight -
              this.$el.firstChild.offsetHeight) /
              2 +
            "px";
        } else {
          this.$el.firstChild.style["margin-top"] = "0px";
        }
      }
    }
  }
};
</script>

<template>
  <el-dialog
    custom-class="operationDialog"
    @close="close"
    :title="title"
    :show-close="showClose"
    :visible="Visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    :width="width"
    :center="center"
    :before-close="beforeClose"
  >
    <slot></slot>
    <span slot="footer" class="dialog-footer" v-if="!hideSave">
      <el-button class="basicBtn" type="primary" :disabled="disabled" @click="confirm">{{btnText}}</el-button>
      <el-button v-if="btnText2" type="primary" @click="confirm2">{{btnText2}}</el-button>
    </span>
  </el-dialog>
</template>


<style lang="scss" >
.operationDialog {
  background-color: #fff;
  border-radius: 12px;
  margin-bottom: 0px !important;
  .el-dialog__header {
    padding: 20px 10px;
    border-bottom: 1px solid #dfdfdf;
    .el-dialog__close {
      font-size: 25px;
    }
  }

  .el-dialog__body {
    // text-align: center;
    font-size: 16px;
    // padding: 10px;
  }
  .el-dialog__footer {
    padding: 0 10px 20px;
    text-align: center;
    .el-button--primary {
      min-width: 88px;
      max-width: 300px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// yotta-vue-components/vision/operationDialog.vue